/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import Date from '../common/components/images/icons/date.svg';
import Club from '../common/components/images/icons/club.svg';
import Email from '../common/components/images/icons/email.svg';
import FieldBasquetbal from '../common/components/images/icons/fieldBasquetbal.svg';
import FieldFutbol from '../common/components/images/icons/fieldFutbol.svg';
import FieldPadelTenis from '../common/components/images/icons/fieldPadelTenis.svg';
import Location from '../common/components/images/icons/location.svg';
import Pay from '../common/components/images/icons/pay.svg';
import PayTotal from '../common/components/images/icons/payTotal.svg';
import Phone from '../common/components/images/icons/phone.svg';
import Time from '../common/components/images/icons/time.svg';
import User from '../common/components/images/icons/user.svg';
import Team from '../common/components/images/icons/equipo.svg';

//const pathname = location.pathname.split('/');
//const sport = pathname.length > 0 ? pathname[1] : 'futbol';

declare const VALID_LAYOUT_VALUES: readonly ['fill', 'fixed', 'intrinsic', 'responsive', undefined];
declare type LayoutValue = typeof VALID_LAYOUT_VALUES[number];
declare type ImgElementStyle = NonNullable<JSX.IntrinsicElements['img']['style']>;

interface ImageProps {
    width?: number;
    height?: number;
    alt: string;
    src: any;
    className?: string;
    layout?: LayoutValue;
    maxWidth?: ImgElementStyle['maxWidth'];
    maxHeight?: ImgElementStyle['maxHeight'];
    minWidth?: ImgElementStyle['minWidth'];
    sport?: string;
}

export default function Icons(props: ImageProps): JSX.Element {
    const { src, alt, width, height, className, minWidth = null, maxWidth = '100%', maxHeight = '100%', sport } = props;

    const imgHeight = height;

    const icons = {
        date: Date,
        club: Club,
        email: Email,
        location: Location,
        pay: Pay,
        payTotal: PayTotal,
        phone: Phone,
        time: Time,
        user: User,
        team: Team,
        field: {
            futbol: FieldFutbol,
            basquetbol: FieldBasquetbal,
            padel: FieldPadelTenis,
            tenis: FieldPadelTenis,
        },
    };

    return (
        <div className={`${className ? className : ''}`}>
            <img
                src={src === 'field' ? (sport ? icons[src][sport] : icons[src]['futbol']) : icons[src]}
                alt={alt}
                style={{
                    maxWidth: maxWidth || minWidth,
                    maxHeight: maxHeight,
                    height: imgHeight,
                    minWidth: minWidth,
                }}
                height={height}
                width={width}
            />
        </div>
    );
}
